import {booker} from "./feature.booker.svelte.js";
import {booking} from "../booking/feature.booking.svelte.js";
import * as booker_select from "./booker.scenarios.select.svelte.js";
import {ENTRY_DURATION_DAY, PAYMENT_TYPE_CREDITCARD, PAYMENT_TYPE_IDEAL, PAYMENT_TYPE_ONSITE, PAYMENT_TYPE_ZERO} from "./../../AppConstants";

/**
 * Moet aangeroepen worden bij elke store mutatie die mogelijk kan beinvloeden
 * welke betaaltypes beschikbaar zijn.
 * Als dus bijvoorbeeld niet meer onsite betaald mag worden als er een non-entree
 * product in de boeking staat, dan moet reevaluateAllowedPaymentMethods altijd
 * aangeroepen worden na een addProduct en een removeProduct

 */
export function reevaluateAllowedPaymentMethods()
{
  // Bepaal de toegestane betaalmethoden
  const aAllowedPaymentMethods = booker_select.getAllowedPaymentMethods();
  booker.aAllowedPaymentMethods = aAllowedPaymentMethods;

  const sPaymentMethod = booker.sPaymentMethod || false;
  const bIsSaunaEntry =
          booking.bShowListOfPackageDeals !== true &&
          booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY;

  // console.log("debug paymentmethod 1", aAllowedPaymentMethods, sPaymentMethod);

  // Controleer of de huidige betaalmethode toegestaan is
  if ( !aAllowedPaymentMethods.includes(sPaymentMethod) )
  {
    // console.log("debug paymentmethod 2", aAllowedPaymentMethods, sPaymentMethod);
    // huidige geselecteerde betaalmethode is niet meer toegestaan.. kies een verstandig alternatief
    if ( aAllowedPaymentMethods.includes(PAYMENT_TYPE_IDEAL) )
    {
      booker.sPaymentMethod = PAYMENT_TYPE_IDEAL;
    }
    else if ( aAllowedPaymentMethods.includes(PAYMENT_TYPE_ONSITE) )
    {
      booker.sPaymentMethod = PAYMENT_TYPE_ONSITE;
    }
    else if ( aAllowedPaymentMethods.includes(PAYMENT_TYPE_CREDITCARD) )
    {
      booker.sPaymentMethod = PAYMENT_TYPE_CREDITCARD;
    }
    else
    {
      // dit komt nooit voor dus hier hoeven we qua validatie in de interface geen rekening mee te houden
      // en daardoor is er frontend altijd een methode geselecteerd
      booker.sPaymentMethod = false;
    }

    // Bij sauna-dagverblijf geen betaalmethode selecteren -> toch wel
    if ( bIsSaunaEntry )
    {
      // 202510 dit uitgezet omdat we sPaymentMethod nooit op false willen.. op die manier is de default fallback altijd iDEAL
      // waarna een eindgebruiker altijd een keuze heeft omdat je nergens in de interface 'niets' kan selecteren
      // booker.sPaymentMethod = false;
    }

    // maar als er niets af te rekenen is gaat dat voor
    if ( aAllowedPaymentMethods.includes(PAYMENT_TYPE_ZERO) )
    {
      // console.log("debug paymentmethod 3", aAllowedPaymentMethods, sPaymentMethod);
      booker.sPaymentMethod = PAYMENT_TYPE_ZERO;
    }
  }
}

export function importFromObject(oInput)
{
  // zie voor onderstaande namen van variabelen het lijstje onderaan reducer_booker
  //if ( typeof oInput.sTitle !== 'undefined' ) booker.sTitle = (oInput.gender_id === '1' ? 'Dhr.' : 'Mvr.');
  if ( typeof oInput.iRelationID !== 'undefined' ) booker.iRelationID = oInput.iRelationID;
  if ( typeof oInput.bHasBadenkaartDayCredit !== 'undefined' ) booker.bHasBadenkaartDayCredit = oInput.bHasBadenkaartDayCredit;
  if ( typeof oInput.bHasBadenkaartShortCredit !== 'undefined' ) booker.bHasBadenkaartShortCredit = oInput.bHasBadenkaartShortCredit;
  if ( typeof oInput.sTitle !== 'undefined' ) booker.sTitle = oInput.sTitle;
  if ( typeof oInput.sName1 !== 'undefined' ) booker.sName1 = oInput.sName1;
  if ( typeof oInput.sName2 !== 'undefined' ) booker.sName2 = oInput.sName2;
  if ( typeof oInput.sName3 !== 'undefined' ) booker.sName3 = oInput.sName3
  if ( typeof oInput.sEmail !== 'undefined' ) booker.sEmail = oInput.sEmail;
  if ( typeof oInput.sTel !== 'undefined' ) booker.sTel = oInput.sTel;
  if ( typeof oInput.sPostalcode !== 'undefined' ) booker.sPostalcode = oInput.sPostalcode;
  if ( typeof oInput.sHouse1 !== 'undefined' ) booker.sHouse1 = oInput.sHouse1;
  // if ( typeof oInput.sHouse2 !== 'undefined' ) booker.sHouse2 = oInput.sHouse2;
  if ( typeof oInput.sStreet !== 'undefined' ) booker.sStreet = oInput.sStreet;
  if ( typeof oInput.sTown !== 'undefined' ) booker.sTown = oInput.sTown;
  if ( typeof oInput.sCountry !== 'undefined' ) booker.sCountry = oInput.sCountry;
  if ( typeof oInput.sComments !== 'undefined' ) booker.sComments = oInput.sComments;
// todo
  // if ( typeof oInput.newsletter !== 'undefined' )
  // {
  //   if ( oInput.bNewsletterIsSubscribed === '1' || oInput.bNewsletterIsSubscribed === 1 || oInput.bNewsletterIsSubscribed === true )
  //   {
  //     booker.bNewsletterIsSubscribed = true;
  //   }
  // }

  // if ( typeof oInput !== 'undefined' ) booker.setIn([ 'sCommentsPreset'], oInput);
}

